<template>
    <section class="main">
        <v-page-header :title="$t('home.quicklinks2.manage_users')" />

        <div class="grid-container" >
            <div class="grid-x">
                <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                    <div class="wrapper">
                        <v-action-buttons :items="getActionButtons"  />

                        <div class="box">
                            <form action="" method="POST" class="filter filter--search" novalidation @submit="onChangeAccountsTableFilter">
                                <div class="form-group form-group--search">
                                    <input type="text" name="search" class="form-control form-control--small form-control--search" :placeholder="$t('search')" v-model="accountsTableFilter.search" />
                                    <button role="button" type="submit" class="button" :title="$t('search')">
                                        {{ $t('search') }}
                                    </button>
                                </div>
                            </form>

                            <v-table :isLoading="accountsTableLoading" :columns="accountsTableColumns" :items="accountsTableItems" :showShowAll="false" :showShowDeactivatedOnly="true" :showDeactivatedOnly="accountsTableFilter.show_deactivated_only"  @onChangeShowDeactivatedOnly="onChangeShowDeactivatedOnlyAccountsTableFilter">
                                <template slot="name" slot-scope="{ row }">
                                    <span class="table-label">{{ row.profile.lastname }}</span>
                                    <span class="table-description">{{ row.profile.firstname }}</span>
                                </template>
                                <template slot="email" slot-scope="{ row }">
                                    <span class="table-label">{{ row.profile.communication.email }}</span>
                                    <span class="table-description">{{ $t('form.account.email') }}</span>
                                </template>
                                <!-- <template slot="userTrackingAcceptedon" slot-scope="{ row }">
                                    <span :class="{ 'u-color--alert': row.userTrackingAcceptedon == null }">
                                        {{
                                            row.userTrackingAcceptedon == null
                                                ? $t('account.message.none_yet')
                                                : $t('date.on') + ' ' + $moment(row.userTrackingAcceptedon.date).format('DD.MM.YYYY')
                                        }}
                                    </span>
                                    <span
                                        class="table-description"
                                        :class="{ 'u-color--alert': row.userTrackingAcceptedon == null }"
                                    >
                                        {{ $t('account.accepted.dsvgo_consent') }}
                                    </span>
                                </template> -->
                                <template slot="shouldReceiveProjectUpdateNotification" slot-scope="{ row }">
                                    <div style="display:inline-block;">
                                        <span class="table-label">
                                            <v-select-active
                                                v-model="row.shouldReceiveProjectUpdateNotification"
                                                className="form-control--extra--small u-maxwidth"
                                                style="--u-maxwidth:100px"
                                                @input="onChangeReceiveProjectUpdateNotifications($event, row.id)" />
                                        </span>
                                            <details class="o-details o-details--text-sm u-extra-xxsmall-margin--top">
                                            <summary>
                                                {{ $t('account.project.email_notification_on_update_title') }}
                                            </summary>

                                            <span>
                                                {{ $t('account.project.email_notification_on_update_description') }}
                                            </span>
                                        </details>
                                    </div>
                                </template>
                                <template slot="user_type" slot-scope="{ row }">
                                    <span class="table-label">{{ row.user_type.name }}</span>
                                    <span class="table-description">{{ $t('form.account.permissions') }}</span>
                                </template>
                                <template slot="status" slot-scope="{ row }">
                                    <span class="table-label">
                                        <v-select-active className="form-control--small" v-model="row.active" @input="onChangeStatus($event, row.id)" />
                                    </span>
                                    <span class="table-description">{{ $t('active') }}</span>
                                </template>
                                <template slot="update" slot-scope="{ row }">
                                    <router-link :to="{ name : 'account-update', params : { account : row.id } }" class="button button--action button--action--edit button--small" :title="$t('update')">
                                        {{ $t('update') }}
                                    </router-link>
                                </template>

                            </v-table>
                            <v-pagination :currentPage="accountsTableCurrentPage" :itemsPerPage="accountsTableItemsPerPage" :items="accountsTableItemsCount" @pageClicked="onChangeAccountsTablePage" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ActionButtons from './../partials/Foundation/ActionButtons';
    import PageHeader from '../partials/PageHeader';
    import PageLoading from '../partials/PageLoading';

    // import moment from 'moment';
    import Table from '../partials/Foundation/Table';
    import Pagination from '../partials/Foundation/Pagination';

    import SelectActive from '../partials/Forms/SelectActive';

    export default {
        data() {
            return {
                accountsTableLoading        : true,
                accountsTableColumns        : [
                    { key: 'name' },
                    { key: 'email' },
                    // { key: 'userTrackingAcceptedon' },
                    { key: 'shouldReceiveProjectUpdateNotification', width: '200px' },
                    { key: 'user_type', width: '' },
                    { key: 'status', width: '120px' },
                    { key: 'update' }
                ],
                accountsTableCurrentPage    : this.$route.query.page || 1,
                accountsTableItemsPerPage   : 20,
                accountsTableItems          : [],
                accountsTableItemsCount     : 0,
                accountsTableFilter         : {
                    search                  : this.$route.query.search || '',
                    show_deactivated_only        : Number(this.$route.query.show_deactivated_only || 0)
                }
            };
        },
        components : {
            vActionButtons      : ActionButtons,
            vPageLoading        : PageLoading,
            vPageHeader         : PageHeader,
            vTable              : Table,
            vPagination         : Pagination,
            vSelectActive       : SelectActive
        },
        created : function () {
            this.onUpdateAccountsTableItems(true);
        },
        computed : {
            getActionButtons : function () {
                let buttons = [];
                if (this.$store.getters.userIsAdmin) {
                    buttons.push({
                        action  : 'create-new',
                        router  : { name : 'account-create' }
                    });
                }

                return buttons;
            }
        },
        methods : {
            onUpdateFilterParameters: function () {
                let query = {
                    'page' : this.accountsTableCurrentPage
                };

                for (let key in this.accountsTableFilter) {
                    if (this.accountsTableFilter[key]) {
                        query[key] = this.accountsTableFilter[key];
                    }
                }

                this.$router.push({query : query});
            },
            onChangeAccountsTablePage : function (page) {
                this.accountsTableCurrentPage = page;

                this.onUpdateAccountsTableItems();
            },
            onChangeAccountsTableFilter : function (event) {
                event.preventDefault();

                this.accountsTableCurrentPage = 1;

                this.onUpdateAccountsTableItems();
            },
            onChangeShowDeactivatedOnlyAccountsTableFilter : function (show) {
                this.accountsTableFilter.show_deactivated_only = show;

                this.onUpdateAccountsTableItems();
            },
            onUpdateAccountsTableItems : function (firstUpdate) {
                if (!firstUpdate) {
                    this.onUpdateFilterParameters();
                }

                let promise = this.$api.clearParams()
                    .addParam('show_deactivated_only', this.accountsTableFilter.show_deactivated_only)
                    .addParam('usertype', 1)
                    .addParam('search', this.accountsTableFilter.search)
                    .setPageParams(this.accountsTableCurrentPage, this.accountsTableItemsPerPage)
                    .get('accounts');

                promise.then((response => {
                    this.accountsTableItems         = response.data.data;
                    this.accountsTableItemsCount    = response.data.meta.pagination.total;

                    this.accountsTableLoading       = false;
                }).bind(this)).catch((error => {
                    this.accountsTableItems         = [];
                    this.accountsTableItemsCount    = 0;

                    this.accountsTableLoading       = false;
                }).bind(this));

                this.accountsTableLoading = true;
            },
            onChangeStatus : function (value, id) {
                let object = {
                    active : value
                };

                let promise = this.$api.clearParams()
                    .post('accounts/' + id + '/activate', object);

                promise.finally((() => {
                    this.accountsTableLoading = false;
                }).bind(this));

                this.accountsTableLoading = true;
            },

            onChangeReceiveProjectUpdateNotifications (value, id) {
                this.accountsTableLoading = true;

                this.$api
                    .clearParams()
                    .post(`accounts/${id}/update`, {
                        shouldReceiveProjectUpdateNotification: value
                    })
                    .catch(error => {
                        console.error('Failed to update user', { error })
                    })
                    .finally(() => {
                      this.accountsTableLoading = false;
                    });
            }
        }
    }
</script>
